import React from 'react';

export const PortalContext = React.createContext(undefined);
